import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { ShoppingCartService } from "../shopping-cart.service";
import { DodoCartProduct } from "../dodo-cart-product.class";
import { NavigationEnd, Router } from "@angular/router";
import { Discount, CartItemGroup, CartItem } from "app/plan/plan.models";
import { filter, takeUntil } from "rxjs/operators";
import { MatDialogRef } from "@angular/material/dialog";
import { CartAmount } from "../shopping-cart.models";
import { LocalStorageService } from "../../../@dodo/local-storage";
import { NestedObjectCheckerService } from "../../_core/services/nested-object-checker.service";
import { MobileProductData } from "app/_core/services/models/Mobile/validate-sim-response";
import { DecimalPipe } from "@angular/common";
import { Subject } from "rxjs";
interface AddressCompState {
	nbnAddrComp: any; // NbnCompositeModel;
}

@Component({
    selector: "cart-panel",
    templateUrl: "./cart-panel.component.html",
    styleUrls: ["./cart-panel.component.scss"],
    standalone: false
})
export class CartPanelComponent implements OnInit, OnDestroy {
	@Input()
	source = " ";

	products: DodoCartProduct[] = [];
	_subTotal = 0;
	_discount: Discount;
	_total = 0;
	_cartTotal: CartAmount = {
		dueToday: 0,
		monthly: 0,
		promoDiscountValue: 0,
		promoDiscountDurationText: "",
		promoDiscountDurationTextDiscount: "",
	};
	_serviceAddress: string;
	public _loaded = false;
	__dialogRef: MatDialogRef<any>;
	_totalCostLabel = "Total monthly cost:";
	_busy = false;
	_totalMonthlyCostForFirstXMonths = "";
	_monthToMonthSetupFee = 0;
	_showDecimalValues = false;
	wizardStep: string;

	_cartItemGroups: CartItemGroup[] = [];
	private unsubscribeAll: Subject<any>;

	groupIcon(product: DodoCartProduct): string {
		let icon = "";

		switch (product.type) {
			case "mobile": {
				icon = "assets/img/icons/cart-group-mobile.svg";
				break;
			}
		}

		return icon;
	}

	groupDetails(product: DodoCartProduct): CartItem[] {
		let groupDetails: CartItem[];

		switch (product.type) {
			case "mobile": {
				groupDetails = this.mobileGroupDetails(product);
				break;
			}
		}

		return groupDetails;
	}

	getFeatureNameForMobile(feature: string, indexCounter: number): string {
		const mobileFeature = feature.split(":");
		let featureName = "";

		if (mobileFeature && mobileFeature.length > 0) {
			featureName = mobileFeature[0];
			if (indexCounter > 0) {
				if (mobileFeature.length === 3) {
					const isRecurring = mobileFeature[2] === "true";
					if (isRecurring) {
						// featureName += " (auto renew)";
					} else {
						featureName += " (once-off)";
					}
				} else {
					featureName += " (once-off)";
				}
			}
		}

		return featureName;
	}

	getFeatureValueTextForMobile(
		feature: string,
		indexCounter: number
	): string {
		const mobileFeature = feature.split(":");
		let featureValueText = "";

		if (mobileFeature && mobileFeature.length > 0) {
			if (indexCounter > 0) {
				if (mobileFeature.length === 3) {
					const isRecurring = mobileFeature[2] === "true";
					if (isRecurring) {
						featureValueText = "/mth";
					} else {
						featureValueText = "";
					}
				} else {
					featureValueText = "";
				}
			} else {
				featureValueText = "/mth";
			}
		}

		return featureValueText;
	}

	getFeatureValueForMobile(feature: string): number {
		const mobileFeature = feature.split(":");
		let featureValue;

		if (mobileFeature && mobileFeature.length > 1) {
			featureValue = mobileFeature[1];
		}

		return featureValue;
	}

	discountValue(
		product: DodoCartProduct,
		discount: number,
		featureValue: number
	): number {
		if (product?.product?.discount?.type === "%") {
			return (
				(Number(featureValue) * product?.product?.discount?.amount) /
				100
			);
		} else {
			return discount;
		}
	}

	mobileGroupDetails(product: DodoCartProduct): CartItem[] {
		const details: CartItem[] = [];
		let indexCounter = 0;

		const discount =
			product.product && product.product.discount
				? product.product.discount.amount
				: 0;
		if (
			product.productInfo &&
			product.productInfo.features &&
			product.productInfo.features.length > 0
		) {
			product.productInfo.features.forEach((feature) => {
				if (feature.indexOf(":") > -1) {
					const featureValue = this.getFeatureValueForMobile(feature);
					const featureName = this.getFeatureNameForMobile(
						feature,
						indexCounter
					);
					const detail: CartItem = {
						name: featureName,
						initialValue:
							discount > 0 && indexCounter === 0
								? "$" + this.formatPriceValue(featureValue)
								: "",
						finalValue:
							discount > 0 && indexCounter === 0
								? "$" +
								this.formatPriceValue(
										featureValue -
											this.discountValue(
												product,
												discount,
												featureValue
											)
								)
								: "$" + this.formatPriceValue(featureValue),
						valueText:
							featureName.indexOf("once-off") > -1 ? "" : "/mth",
					};
					details.push(detail);
					indexCounter += 1;
				}
			});
		}

		return details;
	}

	initialValue(product: DodoCartProduct): string {
		const initialValue = "";

		const fetchCost = undefined; //this.fetchTotalCost(product);

		if (product.product) {
			const discount = product.product.promoDiscountValue
				? product.product.promoDiscountValue
				: 0;

			if (discount === 0) {
				if (product.type === "mobile") {
					if (
						product.product &&
						product.product.discount &&
						product.product.discount.amount > 0
					) {
						let initialPrice = 0;
						let index = 1;

						product.product.planInfo.forEach((item) => {
							const itemSplit = item.split(":");
							if (index == 1) {
								initialPrice += +itemSplit[1];
							} else {
								if (itemSplit[2] && itemSplit[2] == "true") {
									initialPrice += +itemSplit[1];
								}
							}
							index += 1;
						});

						return "$" + this.formatPriceValue(initialPrice);
					} else {
						return "";
					}
				} else {
					return initialValue;
				}
			}

			const monthlyCost = product.product.monthlyCost
				? product.product.monthlyCost
				: 0;

			return (
				"$" + this.formatPriceValue(monthlyCost + discount - fetchCost)
			);
		}

		return initialValue;
	}

	finalValue(product: DodoCartProduct): string {
		const initialValue = "";

		if (product.product) {
			const monthlyCost = product.product.monthlyCost
				? product.product.monthlyCost
				: 0;

			if (monthlyCost === 0) {
				return "";
			}

			return "$" + this.formatPriceValue(monthlyCost);
		}

		return initialValue;
	}

	formatPriceValue(priceValue: number): string {
		if (this._showDecimalValues) {
			return this.__decimalPipe.transform(priceValue, "0.2-2");
		} else {
			if (priceValue % 1 !== 0) {
				this._showDecimalValues = true;
				return this.__decimalPipe.transform(priceValue, "0.2-2");
			}
			return priceValue.toString();
		}
	}

	populateCartItemGroups() {
		const cartItemGroups: CartItemGroup[] = [];
		let hasCostAdded = false;
		console.log("this.products", this.products);
		this.products.forEach((product) => {
			let fetchCost;

			if (
				product &&
				product.product &&
				product.product.monthlyCost >= 0
			) {
				const headerFinalvalue = this.formatPriceValue(
							product.product.monthlyCost - fetchCost
					);
				const cartItemGroup: CartItemGroup = {
					groupIcon: this.groupIcon(product),
					header: {
						name: product.name,
						finalValue:
							product.product && product.product.monthlyCost
								? "$" + headerFinalvalue
								: "",
						initialValue: this.initialValue(product),
						valueText: "/mth",
					},
					details: this.groupDetails(product),
				};

				cartItemGroups.push(cartItemGroup);
				hasCostAdded = true;
			}

		});

		this._cartItemGroups = cartItemGroups;
		console.log("this._cartItemGroups)", this._cartItemGroups);
	}

	constructor(
		private __shoppingCartService: ShoppingCartService,
		private __decimalPipe: DecimalPipe,
		private __router: Router,
		private __localStorageService: LocalStorageService,
		private __nestedObjectCheckerService: NestedObjectCheckerService,
	) {
		this.unsubscribeAll = new Subject();
			this.__shoppingCartService.productsUpdated$
				.pipe(filter((p) => !!p))
				.subscribe((products) => {
					// TODO:: Syed Start to check below block after the  story-OPIT-1968
					this._loaded = true;
					// TODO:: Syed end to check above true condition block after the  story-OPIT-1968
					this.products = products;

					this.populateCartItemGroups();
					this.__updateDiscounts("Mobile");
					this.__updateTotals();

					if (this.isMobileOnly) {
						const add: MobileProductData.ValidateSimAPIResponse = this.__localStorageService.getFromSessionStorage(
							"validate-sim"
						);
						if (
							this.__nestedObjectCheckerService.checkNestedObject(
								"serviceAddress",
								add
							)
						) {
							this._serviceAddress = add.serviceAddress.composite;
						} else {
							this._serviceAddress = "";
						}
					} 

					setTimeout(() => {
						this._loaded = true;
					}, 5);
				});

		this.__shoppingCartService.checkoutButtonBusyStatusUpdated$
			.pipe(filter((p) => p !== undefined))
			.subscribe((b) => {
				this._busy = b;
			});
	}


	_capitalizeFirstLetter(value: string = ""): string {
		value = value
			.toLowerCase()
			.split(" ")
			.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
			.join(" ")
			.concat(" ");

		value = value
			.replace(" Vic ", " VIC ")
			.replace(" Act ", " ACT ")
			.replace(" Nsw ", " NSW ")
			.replace(" Qld ", " QLD ")
			.replace(" Sa ", " SA ")
			.replace(" Tas ", " TAS ")
			.replace(" Wa ", " WA ")
			.replace(" Nt ", " NT ");

		return value.trim();
	}

	__updateTotals() {
		this._cartTotal = this.__shoppingCartService.totalCost;
		this._totalMonthlyCostForFirstXMonths = this._cartTotal.promoDiscountDurationTextDiscount;


		console.log("pc _cartTotal", this._cartTotal);
		this._showDecimalValues =
			this._cartTotal.monthly % 1 != 0 ? true : false;
	}


	__updateDiscounts(service: string) {
		const servicePlan = this.products
			? this.products.find((a) => a.name === service)
			: undefined;
		if (servicePlan && servicePlan.product) {
			this._discount = servicePlan.product.discount;
		}
	}

	_choosePlan(product: DodoCartProduct) {
		switch (product.type) {
			case "mobile":
				this.__router.navigate(["/plan/mobile"]);
				// this.__shoppingCartService.closeCartPanel();
				break;
			default:
				this.__router.navigate(["/plan"]);
				// this.__shoppingCartService.closeCartPanel();
				break;
		}
	}

	ngOnInit() {
		this.__router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				takeUntil(this.unsubscribeAll)
			)
			.subscribe((event: NavigationEnd) => {
				if (event.url.indexOf("setup") > -1) {
					const checkoutData = this.__localStorageService.getFromSessionStorage("checkout");
					if (!this._serviceAddress) {
						this._serviceAddress = checkoutData?.userData?.aboutYou?.primaryAddress
							? checkoutData.userData.aboutYou.primaryAddress
							: "";
					}
				}
			});
	}

	ngOnDestroy() {
		this.unsubscribeAll.next(void 0);
		this.unsubscribeAll.complete();
	}

	private get isMobileOnly(): boolean {
		return this.__shoppingCartService.hasMobile;
	}
}
